export default __webpack_public_path__ + "static/imgBackgroundTablet-9da5c9e907ed25aa0e6c8409779be539.png";